import { LogCannon } from '@ace-clublabs/log-cannon';
import axios from 'axios';
import { AuthorizeApplePay } from '../contracts';

export const AuthorizeApplePayApi =
  (endpoint: string): AuthorizeApplePay =>
  async (gateway, validationURL) => {
    try {
      LogCannon.blast('AuthorizeApplePayApi start', {
        endpoint,
        gateway,
      });
      const response = await axios.get(endpoint, { params: { gateway, ...(validationURL && { validationURL }) } });
      LogCannon.blast('AuthorizeApplePayApi success');
      return Promise.resolve(response.data);
    } catch (error: any) {
      const data = error.response?.data;
      LogCannon.error('AuthorizeApplePayApi error', { error: data?.message || error });
      if (error.response) {
        return Promise.reject({
          message: data?.message,
          requestId: data?.requestId,
        });
      } else {
        return Promise.reject({
          message: error,
        });
      }
    }
  };
